<nb-layout>
    <nb-layout-header fixed>
        <div class="space-between">
            <img src="assets/img/logo1.png" alt="" style="height: 3.5rem;">
            <span style="display: flex;
            align-items: center;">
                <span *ngIf="patient">{{patient.name}}</span>
                <button type="button" class="btn button brand-button logout-button" aria-label="print" (click)="logout();" >Logout</button>
            </span>
        </div>
    </nb-layout-header>

    <nb-layout-column>
        <div class="patient-portal-layout">
            <div class="menu">
                <nb-sidebar  tag="left">
                    <nb-menu [items]="items" id='menuItems'>
                    </nb-menu>
                </nb-sidebar>
            </div>
            <div class="main-body">
                <router-outlet></router-outlet>
            </div>
        </div>
    </nb-layout-column>
</nb-layout>